import { render, staticRenderFns } from "./Abnormal.vue?vue&type=template&id=b3f2a122&scoped=true"
import script from "./Abnormal.vue?vue&type=script&lang=js"
export * from "./Abnormal.vue?vue&type=script&lang=js"
import style0 from "./Abnormal.vue?vue&type=style&index=0&id=b3f2a122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f2a122",
  null
  
)

export default component.exports